'use client';

import PageTab from '@pc/components/molecules/tab/PageTab';
import PageTabsContainer from '@pc/components/molecules/tab/PageTabsContainer';
import { useRouter } from 'next/navigation';

function SignatureEmoticonSubTabs() {
  const router = useRouter();
  return (
    <PageTabsContainer className='mb-10 min-w-[1440px]' contentClassName='w-[1360px] px-10 mx-auto'>
      <PageTab
        includedURLPath='/customer/emoticon/signature/all'
        onClick={() => router.push('/customer/emoticon/signature/all')}
        isMiddleLine
        className='ml-0'
      >
        전체BJ
      </PageTab>
      <PageTab
        includedURLPath='/customer/emoticon/signature/crew'
        onClick={() => router.push('/customer/emoticon/signature/crew')}
        isMiddleLine
      >
        CREW
      </PageTab>
    </PageTabsContainer>
  );
}

export default SignatureEmoticonSubTabs;
